import React from "react";

const GooglePlus = props => (
  <svg viewBox="0 0 21.96 13.95" {...props}>
    <defs />
    <title>Google Plus Icon</title>
    <g>
      <g>
        <path
          fill="currentColor"
          d="M0 6.63A7 7 0 0 1 7 0a7.07 7.07 0 0 1 4.66 1.72 24.83 24.83 0 0 1-1.79 1.84 4.6 4.6 0 0 0-5.43-.14 4.47 4.47 0 0 0-.19 7c2.12 1.93 6.13 1 6.72-2h-4C7 7.56 7 6.77 7 6h6.67a8 8 0 0 1-1.26 5.39 6.88 6.88 0 0 1-7.94 2.11A7 7 0 0 1 0 6.63zM18 4h2v2h2v2h-2v2h-2V8h-2V6h2V4z"
        />
      </g>
    </g>
  </svg>
);

export default GooglePlus;



// WEBPACK FOOTER //
// ./src/icons/GooglePlus.js